export default "__VITE_ASSET__BPPvEw8j__"